import type { NextPage } from 'next';
import Head from 'next/head';

import JobDetailBase from '@domains/job-detail/components/job-detail-base/JobDetailBase';
import { JobGonePage } from '@domains/job-detail/components/job-gone-page';
import { GonePageProps, JobDetailPageProps } from '@domains/job-detail/types/job-detail-page-props';
import { createJobServerSideProps } from '@domains/job-detail/utils/get-server-side-props';

import { useRouterHelper } from '@shared/hooks/use-router-helper';

export const getServerSideProps = createJobServerSideProps('transparent');

type PageProps = JobDetailPageProps | GonePageProps;

const isGonePageProps = (props: PageProps): props is GonePageProps => 'isGone' in props && props.isGone === true;

const JobDetailPage: NextPage<PageProps> = props => {
  const { isPreview } = useRouterHelper();

  if (isGonePageProps(props)) {
    const { suggestedJobs } = props;

    return (
      <>
        <Head>
          <meta name='robots' content='noindex' />
          <meta httpEquiv='status' content='410' />
        </Head>
        <JobGonePage suggestedJobs={suggestedJobs} />
      </>
    );
  }

  const { alternativeJobTitlesByPriority, jobPosition, matchReasonsIsTest, nearbyCities, relatedJobPositions, validThrough } = props;

  return (
    <JobDetailBase
      alternativeJobTitlesByPriority={alternativeJobTitlesByPriority}
      isAnonymized={isPreview}
      jobPosition={jobPosition}
      matchReasonsIsTest={matchReasonsIsTest}
      nearbyCities={nearbyCities}
      relatedJobPositions={relatedJobPositions}
      validThrough={validThrough}
    />
  );
};

export default JobDetailPage;
